<template>
  <div class="agencies-box">
    <div class="personalMainHead">
      <PersonalHead></PersonalHead>
    </div>

    <div class="top_data_box">
      <TopData class="top-data" :contractCount="contractCount" />
    </div>
    <div class="info_box">
      <Search @onSearch="onSearch" @onExport="onExport" />

      <Table :tableData="tableData" @reload="getList" />

      <div class="pagination-box">
        <div class="pagination-left"></div>

        <pagination
          class="pagination"
          :total="total"
          :page.sync="queryParams.pageNumber"
          :limit.sync="queryParams.pageSize"
          :page-sizes="[10, 50, 100, 300]"
          @pagination="onPagination"
        />
      </div>
    </div>

    <Loading v-if="isLoading"></Loading>
  </div>
</template>
  
<script>
import BaseApi from "@lib/baseApi.js";

import PersonalHead from "../../common/PersonalHead.vue";
import TopData from "./components/topData.vue";
import Search from "./components/search.vue";
import Table from "./components/table.vue";
import pagination from "@/components/components/pagination/index.vue";
import Loading from "../../common/Loading.vue";
import download from "@lib/download.js";
import { formatSeconds } from "@lib/date.js";

export default {
  name: "",
  props: {},

  components: {
    PersonalHead,
    TopData,
    Search,
    Table,
    pagination,
    Loading,
  },

  data() {
    return {
      form: {},
      queryParams: {
        pageNumber: 1,
        pageSize: 10,
        // withStat: false,
      },
      tableData: [],
      total: 0,

      // 业务状态：办理中（status=10）、审核中（status=11）、已出证（status=12）、公证审核拒绝（status=14）到期未签署（15）
      contractCount: {
        0: 0, // 全部
        10: 0, // 签署中
        11: 0, // 审核中
        12: 0, // 已出证
        14: 0, // 公证审核拒绝
        15: 0, // 到期未签署

        16: 0, // 办理中拖延1天
        17: 0, // 办理中拖延3天
        18: 0, // 办理中拖延7天
      },
    };
  },

  created() {
    this.getList();
  },
  mounted() {},
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
  methods: {
    getList() {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/contract/v2/list", {
        ...this.queryParams,
      }).then(
        (data) => {
          this.$store.commit("showLoading", false);
          if (data.code == 200) {
            let list = data.datas.list.list;
            let contractCount = data.datas.contractCount;
            if (contractCount && contractCount.length) {
              contractCount.forEach((item) => {
                if (this.contractCount.hasOwnProperty(item.status)) {
                  this.contractCount[item.status] = item.count;
                }
              });
            }
            list.forEach((item, index) => {
              item.index = index + 1;
              item.remindDisabled = false; // 是否禁用提醒按钮
              // 是否可以提醒判断
              if (item.remindDeadline) {
                let date = new Date().getTime();
                let remindDate = new Date(
                  item.remindDeadline.replace(/-/g, "-")
                ).getTime();
                if (date < remindDate) {
                  // 当前时间 小于等于 下次可提醒时间 则禁用提醒
                  item.remindDisabled = true; // 是否禁用提醒按钮
                  item.remindDisabledTime = formatSeconds(remindDate - date);
                  console.log(
                    item.remindDisabledTime,
                    "item.remindDisabledTime"
                  );
                }
              }

              // 办理中预期天数计算
              if (item.bizStatus === "办理中") {
                item.blzDays = 0; // 办理中天数
                let date = new Date().getTime();
                let createDate = new Date(
                  item.createTime.replace(/-/g, "-")
                ).getTime();
                item.blzDays = Math.floor(
                  (date - createDate) / 24 / 60 / 60 / 1000
                );
              }
              // applyProgress 办理进度列表 -1: 未进入小程序，0：进入了小程序， 1-6：小程序完成了第x步
              // > 小程序进入过业务：40%；
              // > 实名认证：50%；
              // > 确认合同：60%；
              // > 公证确认：70%；
              // > 意愿表达：80%；
              // > 签署完成：90%；
              item.applyProgressRatio = 0; // 比例
              if (item.applyProgress === 0) {
                item.applyProgressRatio = 40;
              } else if (item.applyProgress > 0) {
                item.applyProgressRatio = parseInt(40 + 10 * item.applyProgress);
              }
            });
            this.tableData = list;
            this.total = data.datas.list.totalRow;
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {}
      );
    },

    onSearch(data) {
      this.queryParams.pageNumber = 1;
      this.queryParams = {
        ...this.queryParams,
        ...data,
      };
      this.getList();
    },

    onPagination(data) {
      this.queryParams.pageNumber = data.page;
      this.queryParams.pageSize = data.limit;
      this.getList();
    },

    // 导出
    onExport() {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken(
        "/contract/v2/contractManagementExport",
        {
          ...this.queryParams,
          pageSize: 1000,
        },
        "POST",
        false,
        false,
        true,
        "blob"
      )
        .then(
          (res) => {
            this.$store.commit("showLoading", false);
            download(
              new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              }),
              "业务管理",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            );
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
          this.$store.commit("showLoading", false);
        });
    },
  },
};
</script>
  
<style scoped lang='scss'>
.agencies-box {
  background-color: #eaedf1;
  width: 100%;
  //   min-height: 100vh;
  padding-top: 60px;
  .personalMainHead {
    width: 100%;
    height: 60px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
  }

  .top_data_box {
    width: 100%;
    position: fixed;
    top: 60px;
    left: 0;
    background: #eaedf1;
    z-index: 100;
    padding: 20px 0;

    .top-data {
      width: 90%;
      min-width: 1200px;
      min-height: 70px;
      margin: 0 auto;
      background: #eaedf1;
    }
  }

  .info_box {
    width: 90%;
    min-width: 1200px;
    min-height: calc(100vh - 60px);
    overflow: auto;
    background-color: #fff;
    margin: 0 auto;
    padding: 100px 0 0 0;
    box-sizing: border-box;
  }
}
</style>
  